/* Aprende · capa móvil e interactiva (ap-movil). Mejora progresiva: si algo falla, el artículo sigue igual. */
(function(){
  'use strict';
  if (window.__apMovil) return; window.__apMovil = true;
  var S = 'viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"';
  var I = {
    idea:'<svg '+S+'><path d="M9 18h6M10 21h4"/><path d="M12 3a6 6 0 0 0-3.5 10.9c.6.5 1 1.2 1 2.1h5c0-.9.4-1.6 1-2.1A6 6 0 0 0 12 3z"/></svg>',
    cable:'<svg '+S+'><path d="M4 7h4v4H4zM16 13h4v4h-4z"/><path d="M8 9c6 0 2 6 8 6"/><path d="M5 7V4M7 7V4M17 17v3M19 17v3"/></svg>',
    pasos:'<svg '+S+'><path d="M9 6h11M9 12h11M9 18h11"/><path d="M4 6h1M4 12h1M4 18h1"/></svg>',
    check:'<svg '+S+'><circle cx="12" cy="12" r="9"/><path d="m8 12 3 3 5-6"/></svg>',
    tool:'<svg '+S+'><path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.5 2.5-2.1-.4-.4-2.1z"/></svg>',
    alerta:'<svg '+S+'><path d="M12 3 2 20h20L12 3z"/><path d="M12 10v4M12 17.5v.01"/></svg>',
    bolsa:'<svg '+S+'><path d="M6 8h12l-1 12H7L6 8z"/><path d="M9 8a3 3 0 0 1 6 0"/></svg>',
    nota:'<svg '+S+'><path d="M6 3h9l3 3v15H6z"/><path d="M9 10h6M9 14h6M9 18h3"/></svg>',
    lista:'<svg '+S+'><path d="M4 6h16M4 12h16M4 18h10"/></svg>',
    compartir:'<svg '+S+'><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="m8.6 13.5 6.8 4M15.4 6.5l-6.8 4"/></svg>',
    arriba:'<svg '+S+'><path d="M12 19V5M5 12l7-7 7 7"/></svg>',
    zoom:'<svg '+S+'><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5M11 8v6M8 11h6"/></svg>',
    tick:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 5 5 9-10"/></svg>',
    abajo:'<svg '+S+' width="18" height="18"><path d="m6 9 6 6 6-6"/></svg>',
    wa:'<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8s-.4-.1-.6.1-.7.8-.8 1-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.7 11.8 11.8 0 0 0 4.5 4c1.7.7 2.3.8 3.2.6.5-.1 1.5-.6 1.7-1.2s.2-1.1.2-1.2-.2-.2-.5-.3z"/></svg>',
    chat:'<svg '+S+'><path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z"/></svg>',
    dj:'<svg '+S+'><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="7.5" cy="12" r="3"/><circle cx="16.5" cy="12" r="3"/></svg>',
    tv:'<svg '+S+'><rect x="2" y="4" width="20" height="13" rx="2"/><path d="M8 21h8M12 17v4"/></svg>',
    cabina:'<svg '+S+'><rect x="5" y="2" width="14" height="20" rx="2"/><circle cx="12" cy="7" r="2"/><circle cx="12" cy="15" r="4"/></svg>',
    cel:'<svg '+S+'><rect x="7" y="2" width="10" height="20" rx="2"/><path d="M11 18h2"/></svg>',
    mic:'<svg '+S+'><rect x="9" y="2" width="6" height="12" rx="3"/><path d="M5 10a7 7 0 0 0 14 0M12 17v5M8 22h8"/></svg>',
    rayo:'<svg '+S+'><path d="M13 2 4 14h7l-1 8 9-12h-7z"/></svg>',
    amp:'<svg '+S+'><rect x="2" y="7" width="20" height="10" rx="2"/><circle cx="7" cy="12" r="2"/><path d="M12 10h7M12 14h5"/></svg>',
    power:'<svg '+S+'><path d="M12 2v10"/><path d="M18.4 6.6a9 9 0 1 1-12.8 0"/></svg>'
  };
  var movil = window.matchMedia('(max-width: 749px)');
  function $(s,c){return (c||document).querySelector(s)}
  function $$(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))}
  function el(tag,cls,html){var e=document.createElement(tag);if(cls)e.className=cls;if(html!=null)e.innerHTML=html;return e}
  function leer(k){try{return JSON.parse(localStorage.getItem(k)||'null')}catch(e){return null}}
  function guardar(k,v){try{localStorage.setItem(k,JSON.stringify(v))}catch(e){}}
  function norm(t){return (t||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'')}

  /* Contenedor que hace scroll (Horizon usa .page-wrapper) */
  function scroller(){
    var pw=$('.page-wrapper');
    if(pw){var o=getComputedStyle(pw).overflowY; if((o==='auto'||o==='scroll')&&pw.scrollHeight>pw.clientHeight+5) return pw;}
    return document.scrollingElement||document.documentElement;
  }
  function escuchaScroll(fn){
    var pw=$('.page-wrapper'); var t=false;
    function h(){if(t)return;t=true;requestAnimationFrame(function(){t=false;fn()})}
    window.addEventListener('scroll',h,{passive:true}); if(pw) pw.addEventListener('scroll',h,{passive:true});
    window.addEventListener('resize',h);
  }
  function irA(nodo){ if(!nodo) return; nodo.scrollIntoView({behavior:'smooth',block:'start'}); }
  var avisoT;
  function aviso(txt){var a=$('.apm-aviso')||document.body.appendChild(el('div','apm-aviso'));a.textContent=txt;a.classList.add('is-visible');clearTimeout(avisoT);avisoT=setTimeout(function(){a.classList.remove('is-visible')},1800)}

  function icoH2(t){
    t=norm(t);
    if(/frase|resumen|idea|que es/.test(t)) return ['idea',''];
    if(/cable|conector|necesit/.test(t)) return ['cable',''];
    if(/paso/.test(t)) return ['pasos',''];
    if(/verific|comprob|prueba/.test(t)) return ['check','verde'];
    if(/falla|problema|error|no suena/.test(t)) return ['tool','rojo'];
    if(/cuidado|seguri|evite|riesgo/.test(t)) return ['alerta','ambar'];
    if(/producto|equipo/.test(t)) return ['bolsa',''];
    return ['nota',''];
  }
  function icoTema(t){
    t=norm(t);
    if(/dj|controlador/.test(t)) return 'dj';
    if(/televisor|tv/.test(t)) return 'tv';
    if(/microfono/.test(t)) return 'mic';
    if(/celular|computador/.test(t)) return 'cel';
    if(/vatio|potencia-necesito/.test(t)) return 'rayo';
    if(/encender|apagar|orden/.test(t)) return 'power';
    if(/cable|xlr|speakon/.test(t)) return 'cable';
    if(/amplificador/.test(t)) return 'amp';
    if(/cabina|parlante|altavoz/.test(t)) return 'cabina';
    return 'nota';
  }

  /* ---------- ARTÍCULO ---------- */
  function articulo(){
    var cuerpo=$('.ap-cuerpo'); if(!cuerpo) return;
    var clave='apm:'+location.pathname;
    var estado=leer(clave)||{p:[],c:[]};

    // Barra de progreso de lectura
    var prog=el('div','apm-progreso','<span></span>'); document.body.appendChild(prog);

    // Iconos en los H2
    var h2s=$$('h2',cuerpo).filter(function(h){return !h.closest('.ap-productos,.ap-relacionados')});
    h2s.forEach(function(h,i){
      if(!h.id) h.id='seccion-'+(i+1);
      h.setAttribute('data-apm-t',h.textContent.trim());
      var r=icoH2(h.textContent); h.classList.add('apm-h2'); if(r[1]) h.setAttribute('data-tono',r[1]);
      h.insertBefore(el('span','apm-h2__ico',I[r[0]]),h.firstChild);
    });

    // Iconos en callouts
    $$('.ap-callout__titulo',cuerpo).forEach(function(t){
      var c=t.parentNode.className, k=/cuidado|peligro/.test(c)?'alerta':/antes/.test(c)?'lista':'idea';
      t.insertBefore(el('span','apm-callout-ico',I[k]),t.firstChild);
    });

    // Pasos marcables
    var pasos=$$('.ap-paso',cuerpo);
    if(pasos.length){
      var h2p=pasos[0].previousElementSibling; while(h2p&&h2p.tagName!=='H2') h2p=h2p.previousElementSibling;
      var cont=el('span','apm-pasos-cont'); var barra=el('div','apm-pasos-barra','<span></span>');
      var fin=el('div','apm-pasos-fin','Listo: completó todos los pasos. Revise la sección "Cómo verificar".');
      if(h2p){h2p.appendChild(cont); h2p.parentNode.insertBefore(barra,h2p.nextSibling); pasos[pasos.length-1].parentNode.insertBefore(fin,pasos[pasos.length-1].nextSibling);}
      function pintar(){
        var n=pasos.filter(function(p){return p.classList.contains('is-hecho')}).length;
        cont.textContent=n+'/'+pasos.length+' pasos'; barra.firstChild.style.width=(100*n/pasos.length)+'%';
        fin.classList.toggle('is-visible',n===pasos.length);
        var d=$('.apm-dock__pasos'); if(d) d.textContent=n+'/'+pasos.length;
      }
      pasos.forEach(function(p,i){
        var b=el('button','apm-hecho','<span class="apm-hecho__caja">'+I.tick+'</span><span class="apm-hecho__txt">Marcar como hecho</span>');
        b.type='button'; p.appendChild(b);
        function set(on){p.classList.toggle('is-hecho',on);b.setAttribute('aria-pressed',on?'true':'false');b.lastChild.textContent=on?'Hecho':'Marcar como hecho'}
        set(estado.p.indexOf(i)>-1);
        b.addEventListener('click',function(){
          var on=!p.classList.contains('is-hecho'); set(on);
          estado.p=estado.p.filter(function(x){return x!==i}); if(on) estado.p.push(i); guardar(clave,estado); pintar();
          if(on&&movil.matches&&pasos[i+1]&&!pasos[i+1].classList.contains('is-hecho')) setTimeout(function(){irA(pasos[i+1])},250);
        });
        // tocar el título de un paso hecho lo vuelve a abrir
        var tt=$('.ap-paso__titulo',p); if(tt) tt.addEventListener('click',function(e){if(e.target.closest('button'))return; if(p.classList.contains('is-hecho')){p.classList.remove('is-hecho');b.setAttribute('aria-pressed','false');b.lastChild.textContent='Marcar como hecho';estado.p=estado.p.filter(function(x){return x!==i});guardar(clave,estado);pintar()}});
      });
      pintar();
    }

    // Lista de verificación tocable
    $$('.ap-check',cuerpo).forEach(function(ul){
      ul.classList.add('apm-check');
      $$('li',ul).forEach(function(li,i){
        li.setAttribute('role','checkbox'); li.tabIndex=0;
        function set(on){li.classList.toggle('is-ok',on);li.setAttribute('aria-checked',on?'true':'false')}
        set(estado.c.indexOf(i)>-1);
        function tog(){var on=!li.classList.contains('is-ok');set(on);estado.c=estado.c.filter(function(x){return x!==i});if(on)estado.c.push(i);guardar(clave,estado)}
        li.addEventListener('click',tog); li.addEventListener('keydown',function(e){if(e.key===' '||e.key==='Enter'){e.preventDefault();tog()}});
      });
    });

    // Tablas: tarjetas en móvil; fallas en acordeón
    $$('table.ap-tabla',cuerpo).forEach(function(t){
      var ths=$$('thead th',t).map(function(th){return th.textContent.trim()});
      $$('tbody tr',t).forEach(function(tr){$$('td',tr).forEach(function(td,j){if(ths[j]) td.setAttribute('data-etiqueta',ths[j])})});
      if(t.classList.contains('ap-tabla--fallas')){
        var acc=el('div','apm-fallas');
        $$('tbody tr',t).forEach(function(tr){
          var tds=$$('td',tr); if(!tds.length) return;
          var d=el('details','apm-falla');
          var sm=el('summary',null,'<span class="apm-falla__ico">'+I.alerta+'</span><span>'+tds[0].innerHTML+'</span><span class="apm-falla__flecha">'+I.abajo+'</span>');
          var cu=el('div','apm-falla__cuerpo');
          tds.slice(1).forEach(function(td,j){cu.appendChild(el('p','apm-falla__dato','<b>'+(ths[j+1]||'')+'</b>'+td.innerHTML))});
          d.appendChild(sm); d.appendChild(cu); acc.appendChild(d);
        });
        t.parentNode.insertBefore(acc,t.nextSibling); cuerpo.classList.add('apm-con-acordeon');
      } else t.classList.add('apm-tabla-cartas');
    });

    // Diagramas: versión vertical en móvil + visor ampliable
    var visor=el('div','apm-visor','<div class="apm-visor__barra"><span>Diagrama</span><button type="button" class="apm-visor__cerrar" aria-label="Cerrar">✕</button></div><div class="apm-visor__lienzo"><img alt=""></div><p class="apm-visor__ayuda">Pellizque o toque dos veces para acercar</p>');
    visor.setAttribute('role','dialog'); visor.setAttribute('aria-modal','true'); document.body.appendChild(visor);
    var vImg=$('img',visor), lienzo=$('.apm-visor__lienzo',visor);
    function cerrar(){visor.classList.remove('is-abierto');lienzo.classList.remove('is-zoom');document.documentElement.style.overflow=''}
    $('.apm-visor__cerrar',visor).addEventListener('click',cerrar);
    visor.addEventListener('click',function(e){if(e.target===lienzo)cerrar()});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')cerrar()});
    lienzo.addEventListener('dblclick',function(){lienzo.classList.toggle('is-zoom')});
    var hayDiagrama=false;
    $$('figure',cuerpo).forEach(function(f){
      var img=$('img',f); if(!img) return;
      var src=img.currentSrc||img.src; var m=src.match(/^(.*\/)(ap-diagrama-[a-z0-9-]+?)(?:_[0-9a-f-]{36})?\.(webp|png|jpg)/i);
      f.classList.add('apm-fig');
      if(m){
        hayDiagrama=true;
        var movilSrc=m[1]+m[2]+'-movil.webp';
        var prueba=new Image();
        prueba.onload=function(){
          img.setAttribute('data-apm-desk',src); img.setAttribute('data-apm-movil',movilSrc);
          function aplicar(){ if(movil.matches){img.removeAttribute('srcset');img.removeAttribute('sizes');img.src=movilSrc;img.removeAttribute('width');img.removeAttribute('height');} else if(img.src!==src){img.src=src;} }
          aplicar(); if(movil.addEventListener) movil.addEventListener('change',aplicar);
        };
        prueba.src=movilSrc;
      }
      var b=el('button','apm-ampliar',I.zoom+'<span>Ampliar</span>'); b.type='button'; f.appendChild(b);
      function abrir(){vImg.src=img.currentSrc||img.src;vImg.alt=img.alt||'';visor.classList.add('is-abierto');document.documentElement.style.overflow='hidden';$('.apm-visor__cerrar',visor).focus()}
      b.addEventListener('click',abrir); img.addEventListener('click',abrir);
    });
    if(hayDiagrama) document.body.classList.add('apm-sin-portada');

    // Indicador "deslice" en carruseles
    deslizar();

    // Dock inferior + hoja de índice (solo móvil)
    var secciones=h2s.map(function(h){var t=h.getAttribute('data-apm-t')||h.textContent.trim();return {h:h,t:t,i:icoH2(t)}});
    var dock=el('nav','apm-dock');
    dock.setAttribute('aria-label','Navegación de la guía');
    dock.innerHTML='<button type="button" class="apm-dock__indice" aria-label="Abrir índice">'+I.lista+'<span class="apm-dock__actual"><small>En esta guía</small><span class="apm-dock__txt">'+((secciones[0]&&secciones[0].t)||'Índice')+'</span></span></button>'+
      (pasos.length?'<button type="button" class="apm-dock__icono apm-dock__ir-pasos" aria-label="Ir a los pasos">'+I.check+'<span class="apm-dock__pasos"></span></button>':'')+
      '<button type="button" class="apm-dock__icono apm-dock__compartir" aria-label="Compartir">'+I.compartir+'</button>'+
      '<button type="button" class="apm-dock__icono apm-dock__arriba" aria-label="Volver arriba">'+I.arriba+'</button>';
    if(pasos.length){var ip=$('.apm-dock__ir-pasos',dock); ip.style.width='auto'; ip.style.padding='0 10px';}
    var velo=el('div','apm-velo'); var hoja=el('div','apm-hoja');
    hoja.setAttribute('role','dialog'); hoja.setAttribute('aria-label','Índice de la guía');
    var titulo=($('.ap-articulo__titulo')||{}).textContent||document.title;
    hoja.innerHTML='<div class="apm-hoja__asa"></div><p class="apm-hoja__titulo">En esta guía</p><p class="apm-hoja__sub">'+secciones.length+' SECCIONES'+(pasos.length?' · '+pasos.length+' PASOS':'')+'</p><ol>'+
      secciones.map(function(s,k){return '<li><a href="#'+s.h.id+'" data-k="'+k+'"><span class="apm-h2__ico">'+I[s.i[0]]+'</span>'+s.t.replace(/</g,'&lt;')+'</a></li>'}).join('')+
      '</ol><div class="apm-hoja__acciones"><a href="https://wa.me/?text='+encodeURIComponent(titulo.trim()+' '+location.href.split('#')[0])+'" target="_blank" rel="noopener">'+I.wa+'Enviar por WhatsApp</a><a href="/pages/contacto">'+I.chat+'Pedir asesoría</a></div>';
    document.body.appendChild(velo); document.body.appendChild(hoja); document.body.appendChild(dock); document.body.classList.add('apm-con-dock');
    function abrirHoja(){velo.classList.add('is-visible');requestAnimationFrame(function(){hoja.classList.add('is-abierta')})}
    function cerrarHoja(){hoja.classList.remove('is-abierta');velo.classList.remove('is-visible')}
    $('.apm-dock__indice',dock).addEventListener('click',abrirHoja); velo.addEventListener('click',cerrarHoja);
    $$('a[data-k]',hoja).forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();cerrarHoja();irA(secciones[+a.getAttribute('data-k')].h)})});
    $('.apm-dock__arriba',dock).addEventListener('click',function(){var s=scroller(); if(s.scrollTo) s.scrollTo({top:0,behavior:'smooth'}); window.scrollTo({top:0,behavior:'smooth'})});
    if(pasos.length) $('.apm-dock__ir-pasos',dock).addEventListener('click',function(){var p=pasos.filter(function(x){return !x.classList.contains('is-hecho')})[0]||pasos[0]; irA(p)});
    $('.apm-dock__compartir',dock).addEventListener('click',function(){
      var url=location.href.split('#')[0];
      if(navigator.share){navigator.share({title:titulo.trim(),url:url}).catch(function(){});}
      else if(navigator.clipboard){navigator.clipboard.writeText(url).then(function(){aviso('Enlace copiado')},function(){aviso(url)})}
    });
    var dp=$('.apm-dock__pasos'); if(dp&&pasos.length){dp.textContent=pasos.filter(function(p){return p.classList.contains('is-hecho')}).length+'/'+pasos.length}

    // Scroll: progreso, dock visible, sección actual
    var tituloEl=$('.ap-articulo__titulo')||cuerpo;
    function onScroll(){
      var r=cuerpo.getBoundingClientRect(); var vh=window.innerHeight;
      var total=r.height-vh*0.6; var hecho=Math.min(1,Math.max(0,(-r.top+vh*0.25)/(total>0?total:1)));
      prog.firstChild.style.transform='scaleX('+hecho+')';
      dock.classList.toggle('is-visible',tituloEl.getBoundingClientRect().bottom<0);
      var act=0; secciones.forEach(function(s,k){if(s.h.getBoundingClientRect().top<vh*0.35) act=k});
      if(secciones[act]){ $('.apm-dock__txt',dock).textContent=secciones[act].t; $$('a[data-k]',hoja).forEach(function(a,k){a.classList.toggle('is-activo',k===act)}); }
    }
    escuchaScroll(onScroll); onScroll();
  }

  function deslizar(){
    [['.ap-productos__grid','productos'],['.ap-relacionados .ap-grid','guías'],['.ap-banda .ap-grid','guías']].forEach(function(p){
      $$(p[0]).forEach(function(g){ if(g.children.length>1&&!(g.previousElementSibling&&g.previousElementSibling.classList.contains('apm-desliza'))) g.parentNode.insertBefore(el('p','apm-desliza','Deslice para ver más '+p[1]+' →'),g); });
    });
  }
  /* ---------- ÍNDICE DEL BLOG: miniaturas ilustradas ---------- */
  function tarjetas(){
    $$('.ap-tarjeta').forEach(function(t){
      if($('.apm-mini',t)) return;
      var a=$('a.ap-tarjeta__enlace',t); if(!a) return;
      var slug=(a.getAttribute('href')||'').split('/').pop();
      var cat=norm(($('.ap-tarjeta__cat',t)||{}).textContent);
      var tono=/mantenimiento|cuidado/.test(cat)?'ambar':/concepto/.test(cat)?'verde':'';
      var mini=el('span','apm-mini',I[icoTema(slug+' '+norm(($('.ap-tarjeta__titulo',t)||{}).textContent))]);
      if(tono) mini.setAttribute('data-tono',tono);
      var num=$('.ap-tarjeta__num',t); if(num) mini.appendChild(num);
      a.insertBefore(mini,a.firstChild);
    });
  }

  function iniciar(){ try{articulo()}catch(e){console.warn('ap-movil articulo',e)} try{tarjetas();if(!$('.ap-cuerpo'))deslizar()}catch(e){console.warn('ap-movil tarjetas',e)} }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){setTimeout(iniciar,0)}); else setTimeout(iniciar,0);
})();
